import { useEffect, useState } from "react";
import papi from "@/lib/partnerApi";
import { SectionHead } from "./VdaShared";
import { Loader2, ChevronDown, ChevronRight, Radar } from "lucide-react";

export default function VdaActivity() {
  const [runs, setRuns] = useState(null);
  const [open, setOpen] = useState(null);
  useEffect(() => { papi.get("/vda/activity").then((r) => setRuns(r.data)).catch(() => setRuns([])); }, []);

  if (runs === null) return <div className="flex h-64 items-center justify-center"><Loader2 className="h-6 w-6 animate-spin text-teal-500" /></div>;

  return (
    <div>
      <SectionHead title="Activity Logs" desc="Full audit trail of every discovery run." />
      {runs.length === 0 ? <div className="flex h-48 items-center justify-center rounded-2xl border border-slate-200 bg-white text-sm text-slate-400">No runs logged yet.</div> : (
        <div className="space-y-3" data-testid="activity-list">
          {runs.map((r) => (
            <div key={r.id} className="rounded-2xl border border-slate-200 bg-white shadow-sm">
              <button data-testid={`activity-run-${r.id}`} onClick={() => setOpen(open === r.id ? null : r.id)} className="flex w-full items-center gap-4 px-5 py-4 text-left">
                <div className="flex h-10 w-10 items-center justify-center rounded-xl bg-teal-500/10"><Radar className="h-5 w-5 text-teal-600" /></div>
                <div className="flex-1">
                  <p className="font-semibold text-slate-800">{r.category} · {r.city}</p>
                  <p className="text-xs text-slate-400">{new Date(r.created_at).toLocaleString()}</p>
                </div>
                <div className="hidden gap-6 text-sm sm:flex">
                  <Metric label="Discovered" v={r.discovered} /><Metric label="Unique" v={r.unique} accent /><Metric label="Dupes" v={r.duplicates} />
                </div>
                {open === r.id ? <ChevronDown className="h-5 w-5 text-slate-400" /> : <ChevronRight className="h-5 w-5 text-slate-400" />}
              </button>
              {open === r.id && (
                <div className="border-t border-slate-100 px-5 py-4">
                  <ol className="space-y-2">
                    {(r.log || []).map((l, i) => (
                      <li key={i} className="flex gap-3 text-sm">
                        <span className="w-40 shrink-0 font-mono text-xs text-slate-400">{new Date(l.t).toLocaleTimeString()}</span>
                        <span className="text-slate-700">{l.msg}</span>
                      </li>
                    ))}
                  </ol>
                </div>
              )}
            </div>
          ))}
        </div>
      )}
    </div>
  );
}

function Metric({ label, v, accent }) {
  return <div className="text-center"><p className={`text-lg font-bold tabular-nums ${accent ? "text-teal-600" : "text-slate-700"}`}>{v}</p><p className="text-[11px] uppercase tracking-wide text-slate-400">{label}</p></div>;
}
